import {
  AnnouncementBannerSchema
} from "./chunk-YCREDJJH.mjs";
import {
  JustShippedCardSchema
} from "./chunk-SLL5GCR6.mjs";

// src/flags/flags.ts
import { z } from "zod";
var Flag = /* @__PURE__ */ ((Flag2) => {
  Flag2["AlertChannel"] = "alert_channel";
  Flag2["TestingSDK"] = "testing_sdk";
  Flag2["NewCheckoutFlow"] = "new_checkout_flow";
  Flag2["ServicesRedesign"] = "services_redesign";
  Flag2["SignupDeeplink"] = "signup_deeplink_new";
  Flag2["QuickstartReorder"] = "quickstart_reorder";
  Flag2["FaucetDashboardPromo"] = "faucet_dashboard_promo";
  Flag2["UnifyWebhookCreationFlow"] = "unify_webhook_creation_flow";
  Flag2["FeaturedChains"] = "featured_chains";
  Flag2["JustShippedCards"] = "just_shipped_cards";
  Flag2["AnnouncementBanner"] = "announcement_banner";
  Flag2["OutageBanner"] = "outage_banner";
  Flag2["Webhooks"] = "webhooks";
  Flag2["ScheduleCallPopover"] = "schedule_call_popover";
  return Flag2;
})(Flag || {});
var FlagEnum = z.nativeEnum(Flag);
var FLAG_SCHEMA_MAP = {
  // Feature gates
  ["alert_channel" /* AlertChannel */]: z.boolean(),
  ["testing_sdk" /* TestingSDK */]: z.boolean(),
  ["new_checkout_flow" /* NewCheckoutFlow */]: z.boolean(),
  ["services_redesign" /* ServicesRedesign */]: z.boolean(),
  // Experiments
  ["signup_deeplink_new" /* SignupDeeplink */]: z.object({ test: z.boolean() }),
  ["quickstart_reorder" /* QuickstartReorder */]: z.object({
    quickstart_variant: z.union([z.literal("bottom"), z.literal("top")])
  }),
  ["faucet_dashboard_promo" /* FaucetDashboardPromo */]: z.object({ test: z.boolean() }),
  ["unify_webhook_creation_flow" /* UnifyWebhookCreationFlow */]: z.object({ is_test: z.boolean() }),
  // Dynamic configs
  ["featured_chains" /* FeaturedChains */]: z.object({
    featuredChainIds: z.array(z.string()),
    popularChainIds: z.array(z.string())
  }),
  ["just_shipped_cards" /* JustShippedCards */]: z.object({
    cards: z.array(JustShippedCardSchema)
  }),
  ["announcement_banner" /* AnnouncementBanner */]: z.object({
    banners: z.array(AnnouncementBannerSchema)
  }),
  ["outage_banner" /* OutageBanner */]: z.object({
    enabled: z.boolean(),
    message: z.string()
  }),
  ["webhooks" /* Webhooks */]: z.object({
    ADDRESS_ACTIVITY: z.array(z.string()),
    // NetworkId
    GRAPHQL: z.array(z.string()),
    // NetworkId
    NFT_ACTIVITY: z.array(z.string())
    // NetworkId
  }),
  ["schedule_call_popover" /* ScheduleCallPopover */]: z.object({
    ctaText: z.string(),
    ctaUrl: z.string().url(),
    // URLs are already being validated by the Statsig dynamic config
    description: z.string(),
    openPopoverText: z.string()
  })
};
var flagSchemaMap = z.object(FLAG_SCHEMA_MAP);
var FLAG_DEFAULTS = {
  ["alert_channel" /* AlertChannel */]: false,
  ["testing_sdk" /* TestingSDK */]: false,
  ["new_checkout_flow" /* NewCheckoutFlow */]: false,
  ["services_redesign" /* ServicesRedesign */]: false,
  // Experiments
  ["signup_deeplink_new" /* SignupDeeplink */]: { test: false },
  ["quickstart_reorder" /* QuickstartReorder */]: { quickstart_variant: "bottom" },
  ["faucet_dashboard_promo" /* FaucetDashboardPromo */]: { test: false },
  ["unify_webhook_creation_flow" /* UnifyWebhookCreationFlow */]: { is_test: false },
  // Dynamic configs
  ["featured_chains" /* FeaturedChains */]: { featuredChainIds: [], popularChainIds: [] },
  ["just_shipped_cards" /* JustShippedCards */]: { cards: [] },
  ["announcement_banner" /* AnnouncementBanner */]: { banners: [] },
  ["outage_banner" /* OutageBanner */]: { enabled: false, message: "" },
  ["webhooks" /* Webhooks */]: {
    ADDRESS_ACTIVITY: [],
    GRAPHQL: [],
    NFT_ACTIVITY: []
  },
  ["schedule_call_popover" /* ScheduleCallPopover */]: {
    ctaText: "",
    ctaUrl: "",
    description: "",
    openPopoverText: ""
  }
};

export {
  Flag,
  FlagEnum,
  FLAG_SCHEMA_MAP,
  flagSchemaMap,
  FLAG_DEFAULTS
};
//# sourceMappingURL=chunk-QPQIQHGD.mjs.map